module.exports = __webpack_public_path__ + "img/companyEle.771e49ba.svg";